var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.toggleTitle },
    [
      !_vm.user
        ? [
            _c("NsIcon", {
              class: _vm.$style.profileIcon,
              attrs: { "icon-name": "icon-profile", size: "custom" },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                class: _vm.compact
                  ? _vm.$style.signUpCompact
                  : _vm.$style.signUp,
                on: { click: _vm.signUp },
              },
              [_vm._v(_vm._s(_vm.signUpLabel))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: _vm.compact ? _vm.$style.slashCompact : _vm.$style.slash,
              },
              [_vm._v("/")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: _vm.compact
                  ? _vm.$style.signInCompact
                  : _vm.$style.signIn,
                on: { click: _vm.signIn },
              },
              [_vm._v(_vm._s(_vm.signInLabel))]
            ),
          ]
        : [
            !_vm.compact
              ? _c(
                  "button",
                  {
                    class: _vm.$style.maxWidth,
                    on: { click: _vm.redirectToProfile },
                  },
                  [
                    _c("NsIcon", {
                      class: _vm.$style.profileIcon,
                      attrs: { "icon-name": "icon-profile", size: "custom" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              class: _vm.compact
                ? _vm.$style.greetingCompact
                : _vm.$style.greeting,
              domProps: { innerHTML: _vm._s(_vm.greetingText) },
            }),
            _vm._v(" "),
            !_vm.compact
              ? _c("span", { class: _vm.$style.slash }, [_vm._v("/")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.compact
              ? _c(
                  "button",
                  {
                    class: _vm.$style.maxWidth,
                    attrs: { href: _vm.signOutUrl },
                    on: {
                      click: function (event) {
                        return _vm.logout(event)
                      },
                    },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.signOutLabel) + "\n    ")]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }